import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11 12a3 3 0 1 0 6 0a3 3 0 1 0 -6 0","key":"svg-0"}],["path",{"d":"M12 9.765a3 3 0 1 0 0 4.47","key":"svg-1"}],["path",{"d":"M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v10a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2v-10","key":"svg-2"}]]

const IconBrandMastercard = createReactComponent('outline', 'brand-mastercard', 'BrandMastercard', __iconNode);

export default IconBrandMastercard;